export const phoneAreaCode = [
  {
    value: '+61',
    text: '+61',
    name: 'AUSTRALIA',
  },

  {
    value: '+64',
    text: '+64',
    name: 'NEW ZEALAND',
  },
];
